import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { Card, CardBody, CardHeader } from 'reactstrap';

import { fetchComplianceMatrix } from '../../../../../../slices/thunks';
import OPlaceholder from '../../../../../../Components/OElements/OPlaceholder';
import CardWithError from '../../../../../../Components/Common/CardWithError';
import CardWithoutData from '../../../../../../Components/Common/CardWithoutData';

const ComplianceMatrixIObligations = ({ establishment_id, productive_cycle_id, title, subtitle, legendPosition, height, with_total = false, um = '' }) => {
    const dispatch = useDispatch();

    const selector = createSelector(
        state => state.ObligationEstablishments,
        result => ({
            data: result.fetchComplianceMatrix,
            isLoading: result.isObligationEstablishmentLoading,
            isSuccess: result.isObligationEstablishmentSuccess,
            isError: result.isObligationEstablishmentError,
        })
    );

    const { data, isLoading, isSuccess, isError } = useSelector(selector);

    useEffect(() => {
        dispatch(fetchComplianceMatrix({ establishment_id, productive_cycle_id }));
    }, [establishment_id, productive_cycle_id]);


    if (isLoading) {
        return <OPlaceholder />;
    }

    if (isError) {
        return <CardWithError title={title} />;
    }

    if (isSuccess && data && data.headers && data.headers.obligation_statuses) {
        return (
            <React.Fragment>

                <Card className='card-height-100'>
                    <CardHeader className='p-2'>
                        <h5 className="card-title mb-0">{title}</h5>
                    </CardHeader>
                    <CardBody>
                        <table className="table table-bordered fs-12">
                            <thead>
                                <tr>
                                    <th className='text-center' style={{padding:'10px 4px'}} >Criticidad / Cumplimiento</th>
                                    {data.headers.obligation_statuses.map(status => (
                                        <th key={status.name} className='text-center' style={{padding:'10px 4px'}}>
                                            <i className={`${status.icon} align-middle`} style={{ color: status.color }}></i> {status.name}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {Object.entries(data.rows).map(([critName, critDetails]) => (
                                    <tr key={critName}>
                                        <td>
                                            <i className={`${critDetails.icon} align-middle`} style={{ color: critDetails.color }}></i> {critName}
                                        </td>
                                        {data.headers.obligation_statuses.map(status => (
                                            <td key={status.name} className='text-center' style={critDetails.data[status.name] > 0 ? { backgroundColor: status.color, color: '#FFF', fontSize:'1.3em' } : { color: '#CCC'}}>
                                                {critDetails.data[status.name]}
                                            </td>
                                        ))}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </CardBody>
                </Card>
            </React.Fragment>
        );
    }

    return <CardWithoutData title={title} />;

};

export default ComplianceMatrixIObligations;
